/* Odda — Nueva home */
(function () {
  if (window.__oddaHome) return;
  window.__oddaHome = true;

  /* Rotating words in the hero */
  function initWords(root) {
    root.querySelectorAll('[data-odda-words]').forEach(function (el) {
      if (el.__odda) return; el.__odda = true;
      var inner = el.querySelector('.odda-words__inner');
      var count = inner ? inner.children.length : 0;
      if (count < 2) return;
      var i = 0;
      setInterval(function () {
        i = (i + 1) % count;
        inner.style.transform = 'translateY(' + (-0.9 * i) + 'em)';
      }, parseInt(el.getAttribute('data-interval') || '2600', 10));
    });
  }

  /* Open / closed status from "Mon-Sat" hours, Europe/Madrid time */
  function madridNow() {
    var day = 1, mins = 720;
    try {
      var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Madrid', weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(new Date());
      var get = function (t) { var p = parts.find(function (x) { return x.type === t; }); return p ? p.value : ''; };
      day = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(get('weekday'));
      mins = (parseInt(get('hour'), 10) % 24) * 60 + parseInt(get('minute'), 10);
    } catch (e) {}
    return { day: day, mins: mins };
  }
  function toMin(t) { var p = t.trim().split(':'); return parseInt(p[0], 10) * 60 + parseInt(p[1] || '0', 10); }
  function fmt(m) { return String(Math.floor(m / 60)).padStart(2, '0') + ':' + String(m % 60).padStart(2, '0'); }
  function status(spec, days) {
    var slots = (spec || '').split(',').map(function (s) { var r = s.split('-'); return r.length === 2 ? [toMin(r[0]), toMin(r[1])] : null; }).filter(Boolean);
    var openDays = (days || '1,2,3,4,5,6').split(',').map(function (d) { return parseInt(d, 10); });
    var now = madridNow();
    if (!slots.length) return null;
    if (openDays.indexOf(now.day) !== -1) {
      for (var i = 0; i < slots.length; i++) {
        if (now.mins >= slots[i][0] && now.mins < slots[i][1]) return { open: true, text: 'Abierto · cierra a las ' + fmt(slots[i][1]) };
        if (now.mins < slots[i][0]) return { open: false, text: 'Cerrado · abre a las ' + fmt(slots[i][0]) };
      }
    }
    for (var k = 1; k <= 7; k++) {
      var d = (now.day + k) % 7;
      if (openDays.indexOf(d) !== -1) {
        var label = k === 1 ? 'mañana' : 'el ' + ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'][d];
        return { open: false, text: 'Cerrado · abre ' + label + ' a las ' + fmt(slots[0][0]) };
      }
    }
    return null;
  }
  function initStatus(root) {
    root.querySelectorAll('[data-odda-hours]').forEach(function (el) {
      var s = status(el.getAttribute('data-odda-hours'), el.getAttribute('data-odda-days'));
      if (!s) { el.hidden = true; return; }
      el.hidden = false;
      var dot = el.querySelector('.odda-dot');
      var txt = el.querySelector('[data-odda-status-text]');
      if (dot) dot.classList.toggle('is-open', s.open);
      if (txt) txt.textContent = s.text;
    });
  }

  /* Product rail: arrows + vendor filter */
  function initRails(root) {
    root.querySelectorAll('[data-odda-rail-section]').forEach(function (sec) {
      if (sec.__odda) return; sec.__odda = true;
      var rail = sec.querySelector('.odda-rail');
      if (!rail) return;
      var cards = Array.prototype.slice.call(rail.querySelectorAll('.odda-pcard'));
      var count = sec.querySelector('[data-odda-count]');
      function step() { var c = cards.find(function (x) { return !x.hidden; }); return c ? c.getBoundingClientRect().width + 20 : 320; }
      sec.querySelectorAll('[data-odda-dir]').forEach(function (b) {
        b.addEventListener('click', function () { rail.scrollBy({ left: parseInt(b.getAttribute('data-odda-dir'), 10) * step(), behavior: 'smooth' }); });
      });
      sec.querySelectorAll('[data-odda-vendor]').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = b.getAttribute('data-odda-vendor');
          sec.querySelectorAll('[data-odda-vendor]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          var n = 0;
          cards.forEach(function (c) {
            var show = v === '*' || c.getAttribute('data-vendor') === v;
            c.hidden = !show;
            if (show) { n++; var num = c.querySelector('.odda-pcard__n'); if (num) num.textContent = String(n).padStart(2, '0'); }
          });
          if (count) count.textContent = '(' + n + ')';
          rail.scrollLeft = 0;
        });
      });
    });
  }

  /* Accessories: hover list drives preview */
  function initAcc(root) {
    root.querySelectorAll('[data-odda-acc]').forEach(function (sec) {
      if (sec.__odda) return; sec.__odda = true;
      var rows = sec.querySelectorAll('.odda-acc__row');
      var panels = sec.querySelectorAll('.odda-acc__panel');
      var words = sec.querySelectorAll('.odda-acc__word > span');
      function activate(i) {
        rows.forEach(function (r, j) { r.classList.toggle('is-active', i === j); });
        panels.forEach(function (p, j) { p.classList.toggle('is-active', i === j); });
        words.forEach(function (w, j) { w.classList.toggle('odda-chrome-dark', i === j); });
      }
      rows.forEach(function (r, i) {
        r.addEventListener('mouseenter', function () { activate(i); });
        r.addEventListener('focus', function () { activate(i); });
      });
      activate(0);
    });
  }

  function init(root) {
    root = root || document;
    initWords(root); initStatus(root); initRails(root); initAcc(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  setInterval(function () { initStatus(document); }, 60000);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
